module.exports = __webpack_public_path__ + "assets/img/36_657_big.c09566fa.jpg";